import { useCallback, useRef } from "react";
import { throttle } from "lodash";

interface UseThrottledCallbackProps {
  callback?: (...args: any[]) => void;
  wait?: number;
  options?: {
    leading?: boolean;
    trailing?: boolean;
  };
}
const useThrottledCallback = ({
  callback,
  wait = 500,
  options,
}: UseThrottledCallbackProps) => {
  const debouncedFunctionRef = useRef<((...args: any[]) => void) | undefined>(
    undefined
  );
  debouncedFunctionRef.current = callback;
  return useCallback(
    throttle(
      (...args) => {
        // @ts-ignore
        return debouncedFunctionRef.current?.(...args);
      },
      wait,
      { trailing: true, leading: true, ...options }
    ),
    []
  );
};

export default useThrottledCallback;
